import { useEffect, useState } from 'react';

import Router from './Router';
import Login from './pages/Login';

function Auth() {
    const [verified, setVerified] = useState(false);

    useEffect(() => {
        const session_aid = window.sessionStorage.getItem('aid');
        const session_authCode = window.sessionStorage.getItem('authcode');

        if (session_aid && session_authCode) {
            fetch('https://api.kerbo.co.kr/auth?ai=' + session_aid + '&ac=' + session_authCode, {
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then((res) => {
                if (res.ok) {
                    setVerified(true);
                } else {
                    setVerified(false);
                }
            });
        }
    }, []);

    if (verified) {
        return <Router />;
    } else {
        return <Login />;
    }
}

export default Auth;
